module.exports = __webpack_public_path__ + "img/527908.cbc7da2c.svg";